"use client";

import { c as _c } from "react/compiler-runtime";
import { ImageUpload } from "../../image-upload/image-upload";
import { LargeFileUploadAdapter } from "../../large-file-upload/large-file-upload-adapter";
import { useStoreBuilderContext } from "./store-builder-context";
// @todo I think these should be two separate components: for image and for video
export const StoreBuilderUpload = t0 => {
  const $ = _c(30);
  const {
    images,
    fieldPathPrefix: t1,
    className,
    width,
    height,
    onUpload,
    onDelete,
    acceptVideo: t2
  } = t0;
  const fieldPathPrefix = t1 === undefined ? "image." : t1;
  const acceptVideo = t2 === undefined ? false : t2;
  const context = useStoreBuilderContext();
  if (acceptVideo) {
    let t3;
    if ($[0] !== context || $[1] !== fieldPathPrefix || $[2] !== onUpload) {
      t3 = (imageUrl, size) => {
        context.saveSelectedPageSectionField({
          fieldPath: fieldPathPrefix + "src",
          value: imageUrl
        });
        onUpload?.(imageUrl, size);
      };
      $[0] = context;
      $[1] = fieldPathPrefix;
      $[2] = onUpload;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== context || $[5] !== fieldPathPrefix || $[6] !== onDelete) {
      t4 = imageUrl_0 => {
        console.log({
          imageUrl: imageUrl_0,
          fieldPathPrefix
        });
        context.saveSelectedPageSectionField({
          fieldPath: fieldPathPrefix + "src",
          value: null
        });
        onDelete?.(imageUrl_0);
      };
      $[4] = context;
      $[5] = fieldPathPrefix;
      $[6] = onDelete;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== className || $[9] !== height || $[10] !== images || $[11] !== t3 || $[12] !== t4 || $[13] !== width) {
      t5 = <LargeFileUploadAdapter className={className} maxImages={1} width={width} height={height} images={images} onUpload={t3} onDelete={t4} />;
      $[8] = className;
      $[9] = height;
      $[10] = images;
      $[11] = t3;
      $[12] = t4;
      $[13] = width;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    return t5;
  }
  let t3;
  if ($[15] !== context || $[16] !== fieldPathPrefix || $[17] !== onUpload) {
    t3 = (imageUrl_1, size_0) => {
      context.saveSelectedPageSectionField({
        fieldPath: fieldPathPrefix + "src",
        value: imageUrl_1
      });
      onUpload?.(imageUrl_1, size_0);
    };
    $[15] = context;
    $[16] = fieldPathPrefix;
    $[17] = onUpload;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  let t4;
  if ($[19] !== context || $[20] !== fieldPathPrefix || $[21] !== onDelete) {
    t4 = imageUrl_2 => {
      console.log({
        imageUrl: imageUrl_2,
        fieldPathPrefix
      });
      context.saveSelectedPageSectionField({
        fieldPath: fieldPathPrefix + "src",
        value: null
      });
      onDelete?.(imageUrl_2);
    };
    $[19] = context;
    $[20] = fieldPathPrefix;
    $[21] = onDelete;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  let t5;
  if ($[23] !== className || $[24] !== height || $[25] !== images || $[26] !== t3 || $[27] !== t4 || $[28] !== width) {
    t5 = <ImageUpload className={className} maxImages={1} width={width} height={height} images={images} onUpload={t3} onDelete={t4} />;
    $[23] = className;
    $[24] = height;
    $[25] = images;
    $[26] = t3;
    $[27] = t4;
    $[28] = width;
    $[29] = t5;
  } else {
    t5 = $[29];
  }
  return t5;
};